"use client"

import Image from "next/image"
import { cn } from "@/lib/utils"

type AccreditationsSectionProps = {
  title?: string
  subtitle?: string
  logos: string[]
  className?: string
}

export default function AccreditationsSection({
  title = "Acreditaciones",
  subtitle = "Respaldo internacional y alianzas que reflejan la solidez de nuestros programas.",
  logos,
  className,
}: AccreditationsSectionProps) {
  if (!logos.length) return null

  return (
    <section className={cn("bg-white py-12 md:py-16", className)} aria-label={title}>
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div className="max-w-xl">
            <div className="mb-3 text-sm font-bold uppercase tracking-widest text-neutral-500">{title}</div>
            <h2 className="mb-4 text-3xl font-black leading-tight uppercase text-black md:text-4xl lg:text-5xl" style={{ fontFamily: "DIN, sans-serif" }}>
              Nuestros respaldos
            </h2>
            <div className="mb-6 h-1.5 w-24 rounded-full bg-[#fb0009]" />
            <p className="text-base leading-relaxed text-black/80 md:text-lg" style={{ fontFamily: "Montserrat, sans-serif" }}>
              {subtitle}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {logos.map((src, index) => (
              <div key={`${src}-${index}`} className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                <div className="relative aspect-[4/3] w-full">
                  <Image
                    src={src}
                    alt={`${title} ${index + 1}`}
                    fill
                    sizes="(min-width: 1024px) 180px, 45vw"
                    className="object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
